export const GET_FILES = 'GET_FILES';
export const UPDATE_FILE = 'UPDATE_FILE';
export const REMOVE_FILE = 'REMOVE_FILE';